(function() {
    angular.module('tmx-app').controller('customerPortfolioReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'ReportService',
        'ToastService',

        function customerPortfolioReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            ReportService,
            ToastService
        ) {
            var customerPortfolioReportVM = this;
            customerPortfolioReportVM.menu = menu;
            customerPortfolioReportVM.gridData = new kendo.data.ObservableArray([]);
            customerPortfolioReportVM.search = search;
            customerPortfolioReportVM.toggle = toggle;
            customerPortfolioReportVM.isOpen = isOpen;
            customerPortfolioReportVM.clear = clear;
            customerPortfolioReportVM.formatColumnName = tmxUtility.formatColumnName;
            customerPortfolioReportVM.formatAmount= tmxUtility.formatAmount;
            customerPortfolioReportVM.formatDateTime=function(date){
                if(tmxUtility.exists(date)){
                    date= tmxUtility.formatDateTimeForCompany(date)
                    date= date.split(' ');
                    return date[0]+' '+date[1]+' '+date[2];
                }
                    
                return 'N/A';
            };

            (function InitializePage() {
            
            })();

            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }

            function clear() {
                customerPortfolioReportVM.ToDate = null;
                customerPortfolioReportVM.FromDate = null;
                customerPortfolioReportVM.NationalIdentifier=undefined;
               
            }


            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            customerPortfolioReportVM.exportToPdf = exportToPdf;

            function search() {
                if (tmxUtility.exists(customerPortfolioReportVM.ToDate)
                    ||tmxUtility.exists(customerPortfolioReportVM.FromDate) 
                || (tmxUtility.exists(customerPortfolioReportVM.NationalIdentifier) && customerPortfolioReportVM.NationalIdentifier.length > 0)){
                   
                    customerPortfolioReportVM.container.customerPortfolioReport.dataSource.read();   
                }
                else{
                    ToastService.showCustomToast("default", "Please enter atleast one field");
                }
                
            }

            function exportToPdf() {

                if (tmxUtility.exists(customerPortfolioReportVM.ToDate)
                    ||tmxUtility.exists(customerPortfolioReportVM.FromDate) 
                || (tmxUtility.exists(customerPortfolioReportVM.NationalIdentifier) && customerPortfolioReportVM.NationalIdentifier.length > 0)){
                   
                    ReportService.ReportPDF({ StoredProcedure: 'sp_customer_portfolio_report', ReportName: 'Customer_Portfolio_Report', Orientation: 'Portrait', 
                        Arguments: { 
                            StartDate: tmxUtility.exists(customerPortfolioReportVM.FromDate) ? customerPortfolioReportVM.FromDate :undefined,
                            EndDate:tmxUtility.exists(customerPortfolioReportVM.ToDate) ? customerPortfolioReportVM.ToDate :undefined,
                            NationalIdentifier: tmxUtility.exists(customerPortfolioReportVM.NationalIdentifier) ? customerPortfolioReportVM.NationalIdentifier :undefined,
                        } });
                }
                else{
                    ToastService.showCustomToast("default", "Please enter atleast one field");
                }
            }


            var gridColumns = [{
                field: tmxUtility.formatColumnName('NationalIdentifierValue'),
                title: "ID Number",
                type: "text",
                scrollable: false,
                search: true,
                headerTemplate: "<span>ID Number</span>"
            },
            {
                field: tmxUtility.formatColumnName('CustomerName'),
                title: "Account Title",
                type: "text",
                scrollable: false,
                search: true,
                template: "<div> {{dataItem.CustomerName | defaultValue}}</div><span style='margin-left: 0px;' class='subtitle'>{{dataItem.BranchCode}}</span><span style='margin-left: 0px;' class='subtitle'> - {{dataItem.BankAccountNumber }}</span>", 
                headerTemplate: "<span>Account Details</span>"
            },
            {
                field: tmxUtility.formatColumnName('BankAccountNumber'),
                title: "Bank Account Number",
                type: "text",
                hidden:true,
                scrollable: false,
                search: true,
                headerTemplate: "<span>Account No</span>"
            },
            {
                field: tmxUtility.formatColumnName('BranchCode'),
                title: "Branch Code",
                type: "text",
                hidden:true,
                scrollable: false,
                search: true,
                headerTemplate: "<span>Branch Code</span>"
            },
            {
                field: tmxUtility.formatColumnName('DisbursementDate'),
                title: "Loan Date",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{CustomerPortfolioReportCtrl.formatDateTime(dataItem[CustomerPortfolioReportCtrl.formatColumnName('DisbursementDate')])}}",
                headerTemplate: "<span>Loan Date</span>"
            },
            {
                field: tmxUtility.formatColumnName('ExpectedRecoveryDate'),
                title: "Maturity Date",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{CustomerPortfolioReportCtrl.formatDateTime(dataItem[CustomerPortfolioReportCtrl.formatColumnName('ExpectedRecoveryDate')])}}",
                headerTemplate: "<span>Maturity Date</span>"
            },
            {
                field: tmxUtility.formatColumnName('AdvanceAmount'),
                title: "Advance Amount",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{CustomerPortfolioReportCtrl.formatAmount(dataItem[CustomerPortfolioReportCtrl.formatColumnName('AdvanceAmount')])}}",
                headerTemplate: "<span>Advance Amount</span>"
            },
            {
                field: tmxUtility.formatColumnName('ServiceCharges'),
                title: "Service Charges",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{CustomerPortfolioReportCtrl.formatAmount(dataItem[CustomerPortfolioReportCtrl.formatColumnName('ServiceCharges')])}}",
                headerTemplate: "<span>Service Charges</span>"
            },
            {
                field: tmxUtility.formatColumnName('TotalPenalty'),
                title: "Total Penalty",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{CustomerPortfolioReportCtrl.formatAmount(dataItem[CustomerPortfolioReportCtrl.formatColumnName('TotalPenalty')])}}",
                headerTemplate: "<span>Penalty Charges</span>"
            },{
                field: tmxUtility.formatColumnName('RemainingAmount'),
                title: "Balance Amount",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{CustomerPortfolioReportCtrl.formatAmount(dataItem[CustomerPortfolioReportCtrl.formatColumnName('RemainingAmount')])}}",
                headerTemplate: "<span>Balance Amount</span>"
            }
                
            ];


            customerPortfolioReportVM.mainGridOptions = {
                autoBind:false,
                dataSource: {
                    transport: {
                        read: function(o) {
                            
                            var objArgs = {
                                StartDate: tmxUtility.exists(customerPortfolioReportVM.FromDate) ? customerPortfolioReportVM.FromDate :undefined,
                                EndDate:tmxUtility.exists(customerPortfolioReportVM.ToDate) ? customerPortfolioReportVM.ToDate :undefined,
                                NationalIdentifier: tmxUtility.exists(customerPortfolioReportVM.NationalIdentifier) ? customerPortfolioReportVM.NationalIdentifier :undefined,
                                
                            }; 

                            var filters = {
                                "StoredProcedure": "sp_customer_portfolio_report",
                                "Arguments": objArgs,
                                "ReportName": "Customer_Portfolio_Report"
                            };

                            firebase.logTmxEvent('report', { name: 'Customer Portfolio Report' });
                            ReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function(response) {

                                if (response) {
                                    customerPortfolioReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
                            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 20,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "customerPortfolioReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var data = customerPortfolioReportVM.GridResponseData;
                    var gridColumns = customerPortfolioReportVM.container.customerPortfolioReport.columns;                                      
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                                                             
                    sheet.rows = rows; 
                   
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: gridColumns
            };

            
        }
    ]);
})();